import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\TelemetryController::manual
* @see app/Http/Controllers/Admin/TelemetryController.php:627
* @route '/admin/telemetry/sync'
*/
export const manual = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: manual.url(options),
    method: 'post',
})

manual.definition = {
    methods: ["post"],
    url: '/admin/telemetry/sync',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\TelemetryController::manual
* @see app/Http/Controllers/Admin/TelemetryController.php:627
* @route '/admin/telemetry/sync'
*/
manual.url = (options?: RouteQueryOptions) => {
    return manual.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TelemetryController::manual
* @see app/Http/Controllers/Admin/TelemetryController.php:627
* @route '/admin/telemetry/sync'
*/
manual.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: manual.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::queue
* @see app/Http/Controllers/Admin/TelemetryController.php:1024
* @route '/admin/telemetry/sync-last-month'
*/
export const queue = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: queue.url(options),
    method: 'post',
})

queue.definition = {
    methods: ["post"],
    url: '/admin/telemetry/sync-last-month',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\TelemetryController::queue
* @see app/Http/Controllers/Admin/TelemetryController.php:1024
* @route '/admin/telemetry/sync-last-month'
*/
queue.url = (options?: RouteQueryOptions) => {
    return queue.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TelemetryController::queue
* @see app/Http/Controllers/Admin/TelemetryController.php:1024
* @route '/admin/telemetry/sync-last-month'
*/
queue.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: queue.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::status
* @see app/Http/Controllers/Admin/TelemetryController.php:1141
* @route '/admin/telemetry/sync-status'
*/
export const status = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

status.definition = {
    methods: ["get","head"],
    url: '/admin/telemetry/sync-status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\TelemetryController::status
* @see app/Http/Controllers/Admin/TelemetryController.php:1141
* @route '/admin/telemetry/sync-status'
*/
status.url = (options?: RouteQueryOptions) => {
    return status.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TelemetryController::status
* @see app/Http/Controllers/Admin/TelemetryController.php:1141
* @route '/admin/telemetry/sync-status'
*/
status.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::status
* @see app/Http/Controllers/Admin/TelemetryController.php:1141
* @route '/admin/telemetry/sync-status'
*/
status.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: status.url(options),
    method: 'head',
})

